import { DEPARTMENT_IDS } from '@/constants/departments'

/** Departments (besides admins) that may open Operations: sidebar and route guard. */
export const OPERATIONS_DEPARTMENT_IDS: readonly number[] = [
    DEPARTMENT_IDS.TECHNOLOGY,
    DEPARTMENT_IDS.DEVELOPMENT,
]
